import React, { Fragment, useContext, useEffect, useRef } from "react";
import { Grid, Divider, OutlinedInput, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import StoreContext from "../../../context/stores/StoreContext";

const useStyles = makeStyles(() => ({
  input: {
    fontSize: "0.9rem",
    backgroundColor: "white",
  },
  buttonBox: {
    textAlign: "center",
    marginLeft: "0.5rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const StoreActions = ({ fieldsValidation, onChangePage, changeUrl }) => {
  const classes = useStyles();

  const {
    display_content,
    stores_filtered,
    selected_store,
    form_data,
    form_error,
    setDisplayContent,
    filterStores,
    clearFilteredStores,
    createStore,
    updateStore,
    setFormError,
  } = useContext(StoreContext);

  const searchText = useRef("");

  const formValidation = (action) => {
    // Error Checking
    let noError = true;
    Object.values(form_error).map((each) => {
      if (each) noError = false;
    });

    // Field Checking
    let filled = true;
    Object.entries(form_data).map(([key, value]) => {
      const list_check = [
        "base_url",
        "shared_secret",
        "api_key",
        "api_secret",
        "store_name",
      ];
      if (list_check.includes(key) && value === "") {
        filled = false;
        form_error[key] = "Field cannot be empty!";
      }
    });

    // Value Checking
    let changes = false;
    if (action === "update") changes = fieldsValidation(selected_store);

    // Valid To Submit
    let valid = false;
    if (noError && filled) valid = true;
    else setFormError(form_error);

    return {
      valid,
      changes,
    };
  };

  const onSearch = (e) => {
    if (searchText.current.value) {
      searchText.current.value = searchText.current.value
        .toLowerCase()
        .replace(/ /g, "");

      filterStores(e.target.value.replace(/ /g, ""));
    } else {
      clearFilteredStores();
    }
  };

  const onCreate = () => {
    setDisplayContent("Create");
    changeUrl("onCreate", "/store/create");
  };

  const onSave = (action) => {
    const { valid, changes } = formValidation(action);

    if (valid) {
      if (action === "create") createStore();
      if (action === "update") updateStore(changes);
    }
  };

  const onCancel = () => onChangePage();

  useEffect(() => {
    if (!stores_filtered) searchText.current.value = "";
  });

  return (
    <Fragment>
      <Grid item xs={12}>
        <Divider variant="fullWidth" />
      </Grid>
      <Grid item xs={12} container>
        {" "}
        {/* Search Bar */}{" "}
        <Grid item xs={2} container justifyContent="flex-start" alignItems="center">
          <Grid item xs={12}>
            <OutlinedInput
              fullWidth
              type="text"
              margin="dense"
              className={classes.input}
              id="search_text"
              placeholder="Store Name"
              autoFocus={!display_content}
              inputRef={searchText}
              onChange={onSearch}
            />{" "}
          </Grid>{" "}
        </Grid>
        {/* Buttons - Behind */}{" "}
        <Grid item xs container justifyContent="flex-end" alignItems="center">
          {" "}
          {display_content === "" ? (
            <Grid item className={classes.buttonBox}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={onCreate}
              >
                New Store{" "}
              </Button>{" "}
            </Grid>
          ) : (
            <Fragment>
              <Grid item className={classes.buttonBox}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                  onClick={onCancel}
                >
                  Cancel{" "}
                </Button>{" "}
              </Grid>
              <Grid item className={classes.buttonBox}>
                {" "}
                {display_content === "Create" && (
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={() => onSave("create")}
                  >
                    Create{" "}
                  </Button>
                )}
                {display_content === "Edit" && selected_store && (
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={() => onSave("update")}
                  >
                    Save{" "}
                  </Button>
                )}{" "}
              </Grid>{" "}
            </Fragment>
          )}{" "}
        </Grid>{" "}
      </Grid>
      <Grid item xs={12}>
        <Divider variant="fullWidth" />
      </Grid>{" "}
    </Fragment>
  );
};

export default StoreActions;
